const baseLink = '/build-project-eshopper';
export default baseLink;